import { ArrowLeftChunky, ArrowRightChunky } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import classnames from 'classnames';
import React from 'react';
import { NavigationButton } from '../NavigationButton/NavigationButton';

import './NavigationControls.scss';

export const NavigationControls: React.FC<{
    className?: string;
    enableNavigationLooping?: boolean;
    isFirstSlide: boolean;
    isLastSlide: boolean;
    nextSlide: number;
    prevSlide: number;
    setCurrentIndex: (index: number) => void;
    title?: React.ReactNode;
    showNextSlideBtn?: boolean;
    showPrevSlideBtn?: boolean;
}> = ({
    className,
    enableNavigationLooping = false,
    isFirstSlide,
    isLastSlide,
    nextSlide,
    prevSlide,
    setCurrentIndex,
    title,
    showNextSlideBtn = true,
    showPrevSlideBtn = true,
}) => {
    const titleNode = title ? <li>{title}</li> : null;

    const shouldDisableLeftNavigation =
        isFirstSlide && !enableNavigationLooping;
    const shouldDisableRightNavigation =
        isLastSlide && !enableNavigationLooping;
    return (
        <ul
            className={classnames(
                'eds-carousel-swiper-navigation-controls',
                className,
            )}
        >
            {showPrevSlideBtn ? (
                <li>
                    <NavigationButton
                        onClick={() => setCurrentIndex(prevSlide)}
                        icon={<ArrowLeftChunky />}
                        disabled={shouldDisableLeftNavigation}
                        ariaLabel={gettext('Previous slide').toString()}
                        className={classnames({
                            ['eds-carousel-swiper-navigation-controls-disabled']:
                                shouldDisableLeftNavigation,
                        })}
                    />
                </li>
            ) : (
                <div />
            )}

            {titleNode}
            {showNextSlideBtn ? (
                <li>
                    <NavigationButton
                        onClick={() => setCurrentIndex(nextSlide)}
                        icon={<ArrowRightChunky />}
                        disabled={shouldDisableRightNavigation}
                        ariaLabel={gettext('Next slide').toString()}
                        className={classnames({
                            ['eds-carousel-swiper-navigation-controls-disabled']:
                                shouldDisableRightNavigation,
                        })}
                    />
                </li>
            ) : null}
        </ul>
    );
};
